import { lazy } from 'react'

export const CreateOrderLazy = lazy(() => import('./CreateOrder'))
